import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import DTProductSearchView from '../../DTProductSearchView';
import { getSelectedProduct } from 'selectors/tools';

const DTSelectProductNode = () => {
  const dispatch = useDispatch();
  const selectedProduct = useSelector(getSelectedProduct);

  const onNextButtonClick = () => {
    dispatch(addEdgeToDecisionTreePath('product_selected'));
  };

  return <DTProductSearchView onNextButtonClick={onNextButtonClick} isNextButtonActive={!isEmpty(selectedProduct)} />;
};

export default DTSelectProductNode;
